import { Button } from "@amzn/storm-ui";
import * as React from "react";
import styled from "styled-components";

import {
    DivFlexJustifyRight,
    ModalFooterContainer,
} from "../../../common/styled.components";

export interface SharePitchedContentFooterProps {
    handleClose: () => void;
    generateShareUrl: () => Promise<void>;
}

export const ModalFooterSecondaryButton = styled(Button)`
    margin-right: ${({ theme }) => theme.spacing.small.default};
`;

export const SharePitchedContentFooter: React.FunctionComponent<
    SharePitchedContentFooterProps
> = (props: SharePitchedContentFooterProps) => {
    const { generateShareUrl, handleClose } = props;

    return (
        <ModalFooterContainer data-testid="share-pitched-content-footer">
            <DivFlexJustifyRight>
                <ModalFooterSecondaryButton
                    data-testid="share-pitched-content-button"
                    onClick={() => void generateShareUrl()}
                >
                    Generate new link
                </ModalFooterSecondaryButton>
                <Button
                    data-testid="share-pitched-content-done"
                    variant="primary"
                    onClick={() => void handleClose()}
                >
                    Done
                </Button>
            </DivFlexJustifyRight>
        </ModalFooterContainer>
    );
};
